



































































































































import { Component, Vue } from "vue-property-decorator";
import LoaderFadeOut from "@/components/LoaderFadeOut.vue";
import { type } from "os";

@Component({
  components: {
    LoaderFadeOut,
  },
})
export default class PageAboutUs extends Vue {
  public mounted() {
    $(".parallax-mirror").hide();
  }
  private getDiplomaLines(index: number) {
    const locale = this.$i18n.getLocaleMessage(this.$i18n.locale);
    if (!locale) {
      return [];
    }
    const content: any = locale.content;
    if (!content) {
      return [];
    }
    const aboutUs: any = content.aboutUs;
    if (!aboutUs) {
      return [];
    }
    const section: any = aboutUs.section;
    if (!section) {
      return [];
    }
    const diploma = section.diploma;
    if (diploma) {
      return diploma[index].lines;
    }
    return [];
  }
}
